<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.09375 7.03125C9.09375 4.87389 10.8426 3.125 13 3.125C15.1574 3.125 16.9062 4.87389 16.9062 7.03125C16.9062 9.18861 15.1574 10.9375 13 10.9375C10.8426 10.9375 9.09375 9.18861 9.09375 7.03125Z" 
                :fill="color"
            />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M16.9062 10.1562C16.9062 8.43036 18.3054 7.03125 20.0312 7.03125C21.7571 7.03125 23.1562 8.43036 23.1562 10.1562C23.1562 11.8821 21.7571 13.2812 20.0312 13.2812C18.3054 13.2812 16.9062 11.8821 16.9062 10.1562Z" 
                :fill="color"
            />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M2.84375 10.1562C2.84375 8.43036 4.24286 7.03125 5.96875 7.03125C7.69464 7.03125 9.09375 8.43036 9.09375 10.1562C9.09375 11.8821 7.69464 13.2812 5.96875 13.2812C4.24286 13.2812 2.84375 11.8821 2.84375 10.1562Z" 
                :fill="color"
            />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.07277 15.7474C8.32066 13.7963 10.5087 12.5 13 12.5C15.4916 12.5 17.6799 13.7966 18.9277 15.7481C19.7904 17.0973 20.1636 18.7242 19.9885 20.3103C19.9611 20.5582 19.8171 20.7781 19.6008 20.9023C17.6556 22.0184 15.4011 22.6562 13 22.6562C10.5989 22.6562 8.34436 22.0184 6.39921 20.9023C6.18291 20.7781 6.03885 20.5582 6.01149 20.3103C5.83639 18.7239 6.2098 17.0967 7.07277 15.7474Z" 
                :fill="color"
            />
            <path d="M5.79404 14.8476C5.7815 14.8669 5.76903 14.8862 5.75664 14.9056C4.75095 16.478 4.29071 18.3507 4.43199 20.1969C3.79861 20.1007 3.18406 19.9459 2.5942 19.7382L2.47445 19.696C2.256 19.6191 2.10336 19.4207 2.08499 19.1898L2.07492 19.0633C2.06668 18.9598 2.0625 18.8553 2.0625 18.75C2.0625 16.6512 3.71776 14.939 5.79404 14.8476Z" 
                :fill="color"
            />
            <path d="M21.5684 20.1968C21.7096 18.351 21.2496 16.4787 20.2443 14.9064C20.2317 14.8868 20.2191 14.8672 20.2063 14.8476C22.2824 14.9392 23.9375 16.6513 23.9375 18.75C23.9375 18.8553 23.9333 18.9598 23.9251 19.0633L23.915 19.1898C23.8966 19.4207 23.744 19.6191 23.5256 19.696L23.4058 19.7382C22.8161 19.9459 22.2016 20.1006 21.5684 20.1968Z" 
                :fill="color"
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgUsers',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>